// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__dpo1W","wrapper":"Avatar_wrapper__PDkIt","picture":"Avatar_picture__HhgmJ"};